import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import * as Carrom from "carrom-king-engine";
import BattleUtils from "../../../gzp/BattleUtils";
import { BootScene } from "../../BootScene";

export class GameOverPlayerAvatar extends Phaser.GameObjects.Container {

    private gemsLabel: Phaser.GameObjects.Text;
    private gemsCounter: number;

    constructor(scene: Phaser.Scene, isPlayer: boolean) {
        
        super(scene);

        this.x = isPlayer ? -150 : 150;
        this.y = -22;

        let isWinner: boolean;

        if (isPlayer) {
            isWinner = GameVars.playerData.id === GameVars.winningPlayerId;
        } else {
            isWinner = GameVars.adversaryData.id === GameVars.winningPlayerId;
        }

        const avatar = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", isPlayer ? "avatar-gamezop-2" : "avatar-gamezop-3");
        this.add(avatar);
        try {
          if (isPlayer) {
            if (BattleUtils.battlePlayerData.photo && BattleUtils.playerProfileCache) {
              avatar.setTexture(BattleUtils.playerProfileCache);
              avatar.displayHeight = 100;
              avatar.displayWidth = 100;	
            }
            
          } else {
            if (BattleUtils.isBattle) {
              if (BattleUtils.battleOpponentData.photo && BattleUtils.opponentProfileCache) {
                avatar.setTexture(BattleUtils.opponentProfileCache);
                avatar.displayHeight = 100;
                avatar.displayWidth = 100;	
              }
            }
          }
        } catch (e) {
          console.log(e);
        }

        const frame = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "icon_basic_frame");
        this.add(frame); 

        if (isWinner) {

            this.setScale(1.125);

            const crown = new Phaser.GameObjects.Image(this.scene, 0, -58, "texture_atlas_1", "crown_winner");
            crown.setOrigin(.5, 1);
            this.add(crown);

            const rays =  new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "rays");
            rays.setScale(.9);
            this.addAt(rays, 0);

            this.scene.add.tween({
                targets: rays,
                angle: 360,
                ease: Phaser.Math.Easing.Linear,
                duration: 12000,
                repeat: -1
            });

            this.scene.add.tween({
                targets: rays,
                scaleX: 1.15,
                scaleY: 1.15,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 500,
                yoyo: true,
                repeat: -1
            });

            if (isPlayer) {

                this.gemsCounter = (GameVars.gameData.gems - 2 * GameConstants.EXPERT_MATCH_FEE) / 5;

                if (GameVars.difficulty === Carrom.Difficulty.BEGINNER) {
                    this.gemsCounter = (GameVars.gameData.gems - GameConstants.BEGINNER_MATCH_PRIZE) / 5;
                } else {
                    this.gemsCounter = (GameVars.gameData.gems - GameConstants.EXPERT_MATCH_PRIZE) / 5;
                }

                const gemIcon = new Phaser.GameObjects.Image(this.scene, -30, 95, "texture_atlas_1", "icon_top_gems");
                gemIcon.setScale(.45);
                this.add(gemIcon); 
        
                this.gemsLabel = new Phaser.GameObjects.Text(this.scene, 50, 95, GameVars.formatNumber(this.gemsCounter * 5), { fontFamily: "Teko-Medium", fontSize: "28px", color: "#FFFFFF"}); 
                this.gemsLabel.setShadow(0, 1.5, "#061f55", 0, false, true);
                this.gemsLabel.setOrigin(1, BootScene.originY);
                this.add(this.gemsLabel);
                
                if (BattleUtils.isBattle) {
                  this.gemsLabel.visible = false;
                  gemIcon.visible = false;
                }

                this.scene.tweens.add({
                    targets: this,
                    gemsCounter: GameVars.gameData.gems / 5,
                    ease: Phaser.Math.Easing.Linear,
                    duration: 400,
                    delay: 1500,
                    onUpdate: function(): void {
                        this.gemsLabel.text = GameVars.formatNumber(Math.floor(this.gemsCounter) * 5);
                    },
                    onUpdateScope: this
                });
            }

            for (let i = 0; i < 8; i ++) {

                const x = -this.x + (15 - 30 * Math.random());
                const y = 35 + 15 * Math.random();

                const gem = new Phaser.GameObjects.Image(this.scene, x, y, "texture_atlas_1", "icon_top_gems");
                gem.angle = 15 - 30 * Math.random();
                gem.setScale(.65 + .15 * Math.random());
                if (Math.random() > .5) {
                    gem.scaleX *= -1;
                }
                if (i < 3) {
                    gem.tint = 0xAAAAAA;
                } else if (i < 5) {
                    gem.tint = 0xCCCCCC;
                } 
                this.add(gem);
                if (BattleUtils.isBattle) {
                  gem.visible = false;
                }
                const scale = .15;
                const delay = 65 * i + 1800;

                this.scene.tweens.add({
                    targets: gem,
                    x: 10 - 20 * Math.random(),
                    y: 25 + 10 - 20 * Math.random(),
                    scaleX: scale * Math.sign(gem.scaleX),
                    scaleY: scale,
                    alpha: 0,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 900,
                    delay: delay
                });
            }
            
        } else {

            const cloud = new Phaser.GameObjects.Image(this.scene, 0, -28, "texture_atlas_1", "cloud_loser");
            cloud.setScale(1.15);
            this.add(cloud);

            this.scene.add.tween({
                targets: cloud,
                scaleX: 1.2,
                scaleY: 1.05,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 1250,
                yoyo: true,
                repeat: -1
            });

            const rain = new Phaser.GameObjects.Sprite(this.scene, 0, -28, "texture_atlas_1", "cloud_loser");
            rain.setScale(1.15);
            this.scene.add.existing(rain);
            rain.anims.play("rain");
            this.add(rain);

            this.setScale(.9);
        }
    }
}
